(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-image-video-features"]) return;
  try {
    
    $("#{{ modal_id }}").click(function() { $.fancybox({ 'padding' : 0, 'autoScale' : false, 'transitionIn' :
    'none', 'transitionOut' : 'none', 'title' : this.title, 'width' : 680, 'height' : 495, 'href' :
    this.href.replace(new RegExp("watch\\?v=", "i"), 'v/'), 'type' : 'swf', 'swf' : { 'wmode' : 'transparent',
    'allowfullscreen' : 'true' } });
  return false; });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-image-video-primary"] && !window.DesignMode) return;
  try {
    
    $("#{{ modal_id }}").click(function() { $.fancybox({ 'padding' : 0, 'autoScale' : false, 'transitionIn' :
    'none', 'transitionOut' : 'none', 'title' : this.title, 'width' : 680, 'height' : 495, 'href' :
    this.href.replace(new RegExp("watch\\?v=", "i"), 'v/'), 'type' : 'swf', 'swf' : { 'wmode' : 'transparent',
    'allowfullscreen' : 'true' } });
  return false; });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-image-video-versatility"]) return;
  try {
    
    $("#{{ modal_id }}").click(function() { $.fancybox({ 'padding' : 0, 'autoScale' : false, 'transitionIn' :
    'none', 'transitionOut' : 'none', 'title' : this.title, 'width' : 680, 'height' : 495, 'href' :
    this.href.replace(new RegExp("watch\\?v=", "i"), 'v/'), 'type' : 'swf', 'swf' : { 'wmode' : 'transparent',
    'allowfullscreen' : 'true' } });
  return false; });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-video-modal"] && !window.DesignMode) return;
  try {
    
    $("#{{ modal_id }}").click(function() { $.fancybox({ 'padding' : 0, 'autoScale' : false, 'transitionIn' :
    'none', 'transitionOut' : 'none', 'title' : this.title, 'width' : 680, 'height' : 495, 'href' :
    this.href.replace(new RegExp("watch\\?v=", "i"), 'v/'), 'type' : 'swf', 'swf' : { 'wmode' : 'transparent',
    'allowfullscreen' : 'true' } });
  return false; });

  } catch(e) { console.error(e); }
})();
})();
